var CONFUSEDCMS = CONFUSEDCMS || {};
var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {};
CONFUSEDCMS.VIEWMODELS = CONFUSEDCMS.VIEWMODELS || {};

CONFUSEDCMS.VIEWMODELS.breakdown = (function (jQuery, constants) {
    /*
        @Desc   :   Creates a new breakdown view model
    */
    var Vehicle = function (reg, age) {
        this.RegistrationNumber = reg;
        this.VehicleAge = age;
    };

    var Price = function (insurerImageLocation, insurerName, price) {
        this.InsurerImageLocation = insurerImageLocation;
        this.InsurerName = insurerName;
        this.Price = price;
    };

    var setupResultsPanel = function (productType) {
        var $panelElement = jQuery(constants.resultsPagePanelSelector);
        var $localProductImage = jQuery(constants.resultsPageLocalProductImageSelector);
        var $nationalProductImage = jQuery(constants.resultsPageNationalProductImageSelector);
        var $europeanProductImage = jQuery(constants.resultsPageEuropeanProductImageSelector);
        switch (productType) {
            case "National":
                $panelElement.toggleClass(constants.resultsProductTypeLocalClass + " " + constants.resultsProductTypeEuropeanClass, false);
                $panelElement.addClass(constants.resultsProductTypeNationalClass);
                $localProductImage.toggleClass(constants.resultsPageSelectedProductClass, false);
                $nationalProductImage.toggleClass(constants.resultsPageSelectedProductClass, true);
                $europeanProductImage.toggleClass(constants.resultsPageSelectedProductClass, false);
                $localProductImage.attr("disabled", false);
                $nationalProductImage.attr("disabled", true);
                break;
            case "European":
                $panelElement.toggleClass(constants.resultsProductTypeLocalClass + " " + constants.resultsProductTypeNationalClass, false);
                $panelElement.addClass(constants.resultsProductTypeEuropeanClass);
                $localProductImage.toggleClass(constants.resultsPageSelectedProductClass, false);
                $nationalProductImage.toggleClass(constants.resultsPageSelectedProductClass, false);
                $europeanProductImage.toggleClass(constants.resultsPageSelectedProductClass, true);
                $localProductImage.attr("disabled", false);
                $nationalProductImage.attr("disabled", false);
                break;
            default:
                $panelElement.toggleClass(constants.resultsProductTypeEuropeanClass + " " + constants.resultsProductTypeNationalClass, false);
                $panelElement.addClass(constants.resultsProductTypeLocalClass);
                $localProductImage.toggleClass(constants.resultsPageSelectedProductClass, true);
                $nationalProductImage.toggleClass(constants.resultsPageSelectedProductClass, false);
                $europeanProductImage.toggleClass(constants.resultsPageSelectedProductClass, false);
                $nationalProductImage.attr("disabled", false);
                $localProductImage.attr("disabled", true);
                break;
        }
    };

    var setupResultPageWording = function (productType, tripType) {
        var $resultsPageHeading = jQuery(constants.resultsPageHeadingSelector);
        var $resultsPage = jQuery(constants.resultsPageSelector);
        var $localWording = $resultsPage.data(constants.resultsPageHeadingLocalWordingDataAttr);
        var $nationalWording = $resultsPage.data(constants.resultsPageHeadingNationalWordingDataAttr);
        var $euroAnnualWording = $resultsPage.data(constants.resultsPageHeadingEuroAnnualWordingDataAttr);
        var $euroSingleWording = $resultsPage.data(constants.resultsPageHeadingEuroSingleWordingDataAttr);
        switch (productType) {
            case "National":
                $resultsPageHeading.text($nationalWording);
                break;
            case "European":
                if (tripType === "Multi") {
                    $resultsPageHeading.text($euroAnnualWording);
                } else {
                    $resultsPageHeading.text($euroSingleWording);
                }
                break;
            default:
                $resultsPageHeading.text($localWording);
                break;
        }
    };

    var setResultsPageProductType = function (productType) {
        setupResultsPanel(productType);
        setupResultPageWording(productType);
    };

    function breakdownViewModel(riskObject) {
        var self = this;
        self.currentPage = ko.observable(constants.stepNames.InitialisingSpinner);
        self.ShowRegistrationNumberMissingValidation = ko.observable(false);
        self.ShowRegistrationNumberNotFoundValidation = ko.observable(false);
        self.coverTypeHelpTextVisible = ko.observable(false);
        self.Vehicles = ko.observableArray();
        self.regLookup = ko.observable("");
        self.results = ko.observableArray();
        self.selectedVehicle = ko.observable();
        self.Deeplink = ko.observable("");
        self.TopPrice = ko.observable(new Price());
        self.LogBreakdownMi = function (eventSource) {
            try
            {
                if (eventSource)
                {
                    CONFUSEDCMS.eventDecorator.events.miPageEvent({
                        EventType: "breakdown-module-click",
                        EventInfo: { "click-source": eventSource },
                        PartnerId: 0
                    });
                    return;
                }
                console.log("LogBreakdownMi: eventSource was null");
            }
            catch (e)
            {
                console.log("LogBreakdownMi: exception caught: " + e);
            }
        };

        self.DeeplinkClick = function (eventSource, href) {
            if (jQuery(constants.resultsPagePanelSelector)) {
                self.currentPage(constants.stepNames.InitialisingSpinner);
            } else {
                self.currentPage(constants.stepNames.Spinner);
            }
            self.LogBreakdownMi(eventSource);
            setTimeout(function () {
                if (href)
                {
                    window.location.href = window.location.origin + href;
                } else
                {
                    window.location.href = self.Deeplink();
                }
            }, 400);
        };

        self.initFailed = function (message) {
            if (message)
            {
                console.log("breakdown:initFailed(): " + message);
            }
            self.currentPage(constants.stepNames.ErrorPage);
            self.coverType = ko.observable("");
            ko.applyBindings(self, jQuery(CONFUSEDCMS.CONSTANTS.breakdownConstants.containerClass)[0]);
            return self;
        };

        if (!riskObject)
        {
            //No breakdown risk (likely expired quote)
            return self.initFailed("");
        }
        if (riskObject.Vehicles) {
            for (var i = 0; i < riskObject.Vehicles.length; i++)
            {
                var riskVehicle = riskObject.Vehicles[i];
                var vehicle = new Vehicle(riskVehicle.RegistrationNumber, riskVehicle.VehicleAge);
                if (riskVehicle.Selected)
                {
                    self.selectedVehicle(vehicle);
                    self.regLookup(vehicle.RegistrationNumber);
                }
                self.Vehicles.push(vehicle);
            }
        }

        self.coverType = ko.observable("");

        self.NewRegClicked = function () {
            self.regLookup("");
            self.currentPage(constants.stepNames.CoverNewReg);
        };

        self.SavedVehiclesClicked = function () {
            var $regLookup = jQuery("#regNumber");
            if (!$regLookup.valid())
            {
                //clear "NewReg"
                self.regLookup("");
                $regLookup.valid();
            }
            self.ShowRegistrationNumberMissingValidation(false);
            self.currentPage(constants.stepNames.CoverSavedVehicles);
        };
        
        self.CoverLevelSelected = function (value) {
            if (jQuery(constants.resultsPagePanelSelector)) {
                setResultsPageProductType(value);
            }

            if (jQuery(".breakdown-cover-variant").length) {
                if (self.selectedVehicle() !== jQuery("#regNumber").val()) {
                    self.currentPage(constants.stepNames.CoverNewReg);
                }
            }
            self.coverType(value);
            if (self.currentPage() === constants.stepNames.CoverSavedVehicles)
            {
                self.ShowRegistrationNumberMissingValidation(false);
                if (!self.selectedVehicle())
                {
                    //no vehicle selected
                    self.ShowRegistrationNumberMissingValidation(true);
                    return;
                }
                self.ContinueCoverLevelSelected(value);
            } else if (self.currentPage() === constants.stepNames.CoverNewReg)
            {
                if (!jQuery("#regNumber").valid())
                {
                    return;
                }
                var reg = self.regLookup().toUpperCase();
                if (!reg)
                {
                    self.ShowRegistrationNumberMissingValidation(true);
                }

                else
                {
                    var regAlreadyInListAtIndex = -1;
                    for (var r = 0; r < self.Vehicles().length; r++)
                    {
                        if (self.Vehicles()[r].RegistrationNumber === reg)
                        {
                            regAlreadyInListAtIndex = r;
                        }
                    }

                    if (regAlreadyInListAtIndex !== -1)
                    {
                        //registration number was already in the users vehicle list
                        self.selectedVehicle(self.Vehicles()[regAlreadyInListAtIndex]);
                        self.ContinueCoverLevelSelected(value);
                    }
                    else
                    {
                        jQuery.ajax({
                            type: "POST",
                            url: "/api/lookup/RegLookup",
                            contentType: "text/json",
                            data: ko.toJSON({ RegistrationNumber: reg }),
                            dataType: "json",
                            success: function (result) {
                                if (result.RegistrationNumber &&
                                    result.RegistrationNumber.length > 0 &&
                                    result.VehicleAge > 0)
                                {
                                    var vehicle = new Vehicle(result.RegistrationNumber, result.VehicleAge);

                                    self.Vehicles.push(vehicle);
                                    self.selectedVehicle(vehicle);
                                    self.ContinueCoverLevelSelected(value);
                                } else
                                {
                                    self.ShowRegistrationNumberNotFoundValidation(true);
                                }
                                return;
                            },
                            error: function (err) {
                                self.ShowRegistrationNumberNotFoundValidation(true);
                                console.log(err);
                            },
                            timeout: 20000
                        });
                    }
                }
            }
        };

        self.ContinueCoverLevelSelected = function (value) {
            self.ShowRegistrationNumberNotFoundValidation(false);
            self.ShowRegistrationNumberMissingValidation(false);
            self.coverTypeHelpTextVisible(false);
            if (value === "European")
            {
                self.breakdownRisk.CoverLevel = ("3");
                self.currentPage(constants.stepNames.CoverTripType);
            } else
            {
                if (value === "National")
                {
                    self.breakdownRisk.CoverLevel = ("2");
                } else
                {
                    //Local
                    self.breakdownRisk.CoverLevel = ("1");
                }
                submitRiskViewModel();
            }
        };

        self.TripTypeClicked = function (value) {
            if (jQuery(constants.resultsPagePanelSelector)) {
                setupResultPageWording("European", value);
            }
            if (value === "Multi")
            {
                self.breakdownRisk.TripDetails.TripType = "1"; //"Annual multi-trip"
                submitRiskViewModel();
            } else
            {
                self.breakdownRisk.TripDetails.TripType = "2"; //"Single trip"
                self.breakdownRisk.TripDetails.TripStartDate = ("");
                self.breakdownRisk.TripDetails.TripEndDate = ("");
                self.currentPage(constants.stepNames.CoverDuration);
            }
        };

        self.ToggleCoverTypeHelpText = function () {
            self.coverTypeHelpTextVisible(!self.coverTypeHelpTextVisible());
        };

        //trigger this method when end date is selected
        self.CoverDurationNextClick = function () {
            var startValid = jQuery("#cover-start-date").valid();
            var endValid = jQuery("#cover-end-date").valid();
            if (startValid && endValid)
            {
                submitRiskViewModel();
            } 
        };

        self.ResetToFirstPage = function () {
            self.ShowRegistrationNumberMissingValidation(false);
            self.ShowRegistrationNumberNotFoundValidation(false);
            self.results([]);

            if (self.Vehicles().length > 0)
            {
                self.currentPage(constants.stepNames.CoverSavedVehicles);
            } else
            {
                self.currentPage(constants.stepNames.CoverNewReg);
            }
        };

        //Risk object we intend to submit
        self.breakdownRisk = {
            CoverLevel: ko.observable(0),
            TripDetails: {
                TripType: ko.observable(0),
                TripStartDate: ko.observable(""),
                TripEndDate: ko.observable("")
            },
            VehicleAge: ko.computed(function () {
                if (self.Vehicles().length > 0) {
                    var selectedVehicle = self.selectedVehicle();
                    if (selectedVehicle !== undefined && selectedVehicle !== null)
                    {
                        return selectedVehicle.VehicleAge;
                    }
                }
                return 0;
            })
        };

        self.getSerializedRiskObject = function () {
            return ko.toJSON(self.breakdownRisk);
        };

        jQuery("div.breakdown-steps input#regNumber").on("keydown",function (event) {
            if (event.which === 32)
            {
                //Disable Space keys
                return false;
            }
            if (event.which === 13)
            {
                //Enter keypress - Disable submit
                event.preventDefault();

                //animate button borders
                var $buttons;
                if (constants.resultsPagePanelSelector) {
                    $buttons = jQuery(".breakdown-widget-image-button"); 
                }else{
                    $buttons = jQuery("div.breakdown-widget__cover-type__button");
                }
                var buttonStyles = $buttons.first().attr("style");
                if (buttonStyles === undefined)
                {
                    buttonStyles = "";
                }
                $buttons.attr("style", buttonStyles + " border-style:solid; border-color:red")
                    .animate({ "borderWidth": "4" }, 100)
                    .delay(150)
                    .animate({ "borderWidth": "0" }, 100);
                setTimeout(function () {
                    $buttons.attr("style", buttonStyles);
                }, 350);
            }
        });

        var submitRiskViewModel = function () {
            self.results.removeAll();
            if (self.breakdownRisk.CoverLevel === "3" /* European */ &&
                self.breakdownRisk.TripDetails.TripType === "2" /* Single trip*/)
            {
                try
                {
                    var $startDate = jQuery("#cover-start-date");
                    var $endDate = jQuery("#cover-end-date");

                    //Populate cover start & end dates in BreakdownRisk model
                    if (Modernizr &&
                        Modernizr.touch &&
                        Modernizr.inputtypes.date &&
                        $startDate &&
                        $startDate.val() &&
                        $endDate &&
                        $endDate.val())
                    {
                        //set model from native date fields
                        self.breakdownRisk.TripDetails.TripStartDate = new Date($startDate.val());
                        self.breakdownRisk.TripDetails.TripEndDate = new Date($endDate.val());
                    } else
                    {
                        //set model from datepickers
                        self.breakdownRisk.TripDetails.TripStartDate = $startDate.datepicker("getDate");
                        self.breakdownRisk.TripDetails.TripEndDate = $endDate.datepicker("getDate");
                    }
                    self.breakdownRisk.TripDetails.TripStartDate
                        .setHours(self.breakdownRisk.TripDetails.TripStartDate.getHours() + 3);
                    self.breakdownRisk.TripDetails.TripEndDate
                        .setHours(self.breakdownRisk.TripDetails.TripEndDate.getHours() + 3);
                } catch (exception)
                {
                    console
                        .log("CONFUSEDCMS.VIEWMODELS.breakdown - submitRiskViewModel(): problem setting start & end date " + exception.message);
                }
            }
            var serializedRisk = self.getSerializedRiskObject(); //Strips observables()
            jQuery.ajax({
                type: "POST",
                url: "/api/breakdown/breakdown/NewQuote",
                contentType: "text/json",
                data: serializedRisk,
                dataType: "json",
                success: function (result) {
                    if (!result)
                    {
                        self.currentPage(constants.stepNames.ErrorPage);
                        return;
                    }
                    if (result.QuoteId > 0 && result.ResultObjectCollection.length > 0)
                    {
                        for (var r = 0; r < result.ResultObjectCollection.length; r++) {
                            self.results.push(
                                new Price(result.ResultObjectCollection[r].InsurerImageLocation,
                                          result.ResultObjectCollection[r].InsurerName,
                                          "£" + result.ResultObjectCollection[r].Price.toFixed(2)));
                        }
                        self.TopPrice(new Price(result.ResultObjectCollection[0].InsurerImageLocation, result.ResultObjectCollection[0].InsurerName, "£" + result.ResultObjectCollection[0].Price.toFixed(2)));
                        self.Deeplink(result.Deeplink);
                        self.currentPage(constants.stepNames.Prices);
                    } else
                    {
                        self.currentPage(constants.stepNames.NoPrices);
                    }
                },
                error: function () { self.currentPage(constants.stepNames.ErrorPage); },
                timeout: 20000
            });
            self.currentPage(constants.stepNames.Spinner);
            self.currentPage.subscribe(function(newValue) {
                CONFUSEDWEBSITE.removeHeights("." + CSSCONSTANTS.equalizeHeightNonMobileClass);
                CONFUSEDWEBSITE.removeHeights("." + CSSCONSTANTS.equalizeHeightDesktopClass);
                var $groupsToEqualize = jQuery("." + CSSCONSTANTS.equalizeHeightSetNonMobileClass);
                CONFUSEDWEBSITE.equalizeHeights($groupsToEqualize,"." + CSSCONSTANTS.equalizeHeightNonMobileClass);
            });
        };
        ko.applyBindings(self, jQuery(CONFUSEDCMS.CONSTANTS.breakdownConstants.containerClass)[0]);
        if (self.Vehicles().length > 0)
        {
            self.currentPage(constants.stepNames.CoverSavedVehicles);
        } else
        {
            self.currentPage(constants.stepNames.CoverNewReg);
        }
        jQuery("#regNumber").on("focus", function () {
            self.ShowRegistrationNumberNotFoundValidation(false);
            self.ShowRegistrationNumberMissingValidation(false);
        });
        return self;
    }

    return {
        create: function () {
            try
            {
                jQuery.ajax({
                    type: "GET",
                    url: "/api/breakdown/breakdown/GetBreakdownModelData",
                    contentType: "text/json",
                    dataType: "json",
                    success: function (result) {
                        return new breakdownViewModel(result);
                    },
                    error: function (result) {
                        return new breakdownViewModel(result);
                    },
                    timeout: 20000
                });
            } catch (ex)
            {
                console.log("Caught Exception" + ex);
                this.currentPage(constants.stepNames.ErrorPage);
                return null;
            }
            return null;
        }
    };
})(jQuery, CONFUSEDCMS.CONSTANTS.breakdownConstants);